<section class="about-us " id="about-us">
    <div class="container about_us">
        <div class="row">
            <div class="col-md-2 "></div>
            <div class="col-md-10 ">
                <div class="header-block">
                    <h2>{{"HOME.about-us-ai.title" | translate}}</h2>
                    <p>
                        {{'HOME.about-us-ai.text' | translate}}
                    </p>
                </div>
            </div>
        </div>
        <app-about-us-ai-item [item]="item" *ngFor="let item of data"></app-about-us-ai-item>
    </div>
</section>
